import {
  DIGITAL_ASSETS_REQUEST,
  DIGITAL_ASSETS_SUCCESS,
  DIGITAL_ASSETS_FAILURE,
  HEADER_LINKS_REQUEST,
  HEADER_LINKS_SUCCESS,
  HEADER_LINKS_FAILURE,
  ECXLUSIVE_UPDATES_REQUEST,
  ECXLUSIVE_UPDATES_SUCCESS,
  ECXLUSIVE_UPDATES_FAILURE,
  PRODUCT_INFO_REQUEST,
  PRODUCT_INFO_SUCCESS,
  PRODUCT_INFO_FAILURE,
  PRODUCT_INFO_UPDATE_REQUEST,
  PRODUCT_INFO_UPDATE_SUCCESS,
  PRODUCT_INFO_UPDATE_FAILURE,
  ALL_DETAILS_REQUEST,
  ALL_DETAILS_SUCCESS,
  ALL_DETAILS_FAILURE,
  GET_NPS_FEEDBACK_REQUEST,
  GET_NPS_FEEDBACK_SUCCESS,
  GET_NPS_FEEDBACK_FAILURE,
  GET_NPS_RATING_REQUEST,
  GET_NPS_RATING_SUCCESS,
  GET_NPS_RATING_FAILURE,
  GET_DASHBOARD_STATS_REQUEST,
  GET_DASHBOARD_STATS_SUCCESS,
  GET_DASHBOARD_STATS_FAILURE,
  PRODUCT_SIGNUP_REQUEST,
  PRODUCT_SIGNUP_SUCCESS,
  PRODUCT_SIGNUP_FAILURE,
  GET_SE_URL_REQUEST,
  GET_SE_URL_SUCCESS,
  GET_SE_URL_FAILURE,
  UPDATE_SE_URL_REQUEST,
  UPDATE_SE_URL_SUCCESS,
  UPDATE_SE_URL_FAILURE,
  SET_DIGITAL_IMAGE_PREVIEW
} from './constants';
import I18n from '../../config/locales';

let initialState = {
  loading: false,
  digitalAssets: [],
  headerBarLinks: {},
  exclusiveUpdates: [],
  productInfo: [],
  message: '',
  messageType: '',
  feedbacks: [],
  ratings: {},
  storeCredits: {},
  shareData: {},
  userCertification: {},
  allFeedbacks: [],
  digitalAssetsImgPreview: {},
  installerSEUrl: '',
  installerSEUrlMapping: {}
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case DIGITAL_ASSETS_REQUEST:
      return { ...state, loading: true };
    case DIGITAL_ASSETS_SUCCESS:
      return { ...state, loading: false, digitalAssets: action.digitalAssets };
    case DIGITAL_ASSETS_FAILURE:
      return { ...state, loading: false };
    case HEADER_LINKS_REQUEST:
      return { ...state, loading: true };
    case HEADER_LINKS_SUCCESS:
      return { ...state, loading: false, headerBarLinks: action.headerBarLinks };
    case HEADER_LINKS_FAILURE:
      return { ...state, loading: false };
    case ECXLUSIVE_UPDATES_REQUEST:
      return { ...state, loading: true };
    case ECXLUSIVE_UPDATES_SUCCESS:
      return { ...state, loading: false, exclusiveUpdates: action.exclusiveUpdates };
    case ECXLUSIVE_UPDATES_FAILURE:
      return { ...state, loading: false };
    case PRODUCT_INFO_REQUEST:
      return { ...state, loading: true };
    case PRODUCT_INFO_SUCCESS:
      return { ...state, loading: false, productInfo: action.productInfo };
    case PRODUCT_INFO_FAILURE:
      return { ...state, loading: false };
    case PRODUCT_INFO_UPDATE_REQUEST:
      return { ...state, loading: true };
    case PRODUCT_INFO_UPDATE_SUCCESS:
      return { ...state, loading: false, message: I18n.t('message.accessRequestSuccess'), messageType: 'success' };
    case PRODUCT_INFO_UPDATE_FAILURE:
      return { ...state, loading: false, message: action.error, messageType: 'error' };
    case ALL_DETAILS_REQUEST:
      return { ...state, loading: true };
    case ALL_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        digitalAssets: action.digitalAssets,
        headerBarLinks: action.headerBarLinks,
        exclusiveUpdates: action.exclusiveUpdates,
        productInfo: action.productInfo,
        storeCredits: action.storeCredits,
        shareData: action.shareData,
        userCertification: action.userCertification
      };
    case ALL_DETAILS_FAILURE:
      return { ...state, loading: false, message: action.error, messageType: 'error' };
    case GET_NPS_FEEDBACK_REQUEST:
      return { ...state, loading: true };
    case GET_NPS_FEEDBACK_SUCCESS:
      return {
        ...state,
        loading: false,
        feedbacks: action.feedbacks,
        allFeedbacks: action.allFeedbacks || state.allFeedbacks
      };
    case GET_NPS_FEEDBACK_FAILURE:
      return { ...state, loading: false, message: action.error, messageType: 'error' };
    case GET_NPS_RATING_REQUEST:
      return { ...state, loading: true };
    case GET_NPS_RATING_SUCCESS:
      return { ...state, loading: false, ratings: action.ratings };
    case GET_NPS_RATING_FAILURE:
      return { ...state, loading: false, message: action.error, messageType: 'error' };
    case GET_DASHBOARD_STATS_REQUEST:
      return { ...state, loading: true };
    case GET_DASHBOARD_STATS_SUCCESS:
      return { ...state, loading: false, dashboardStats: action.dashboardStats };
    case GET_DASHBOARD_STATS_FAILURE:
      return { ...state, loading: false, message: action.error, messageType: 'error' };
    case PRODUCT_SIGNUP_REQUEST:
      return { ...state, loading: true };
    case PRODUCT_SIGNUP_SUCCESS:
      return { ...state, loading: false, message: I18n.t('message.accessRequestSuccess'), messageType: 'success' };
    case PRODUCT_SIGNUP_FAILURE:
      return { ...state, loading: false, message: action.error, messageType: 'error' };
    case GET_SE_URL_REQUEST:
      return { ...state, loading: true };
    case GET_SE_URL_SUCCESS:
      return {
        ...state,
        loading: false,
        installerSEUrl: action.seUrl,
        installerSEUrlMapping: action.installerSEUrlMapping
      };
    case GET_SE_URL_FAILURE:
      return { ...state, loading: false, message: action.error, messageType: 'error' };
    case UPDATE_SE_URL_REQUEST:
      return { ...state, loading: true };
    case UPDATE_SE_URL_SUCCESS:
      return {
        ...state,
        loading: false,
        installerSEUrl: action.seUrl,
        installerSEUrlMapping: action.installerSEUrlMapping
      };
    case UPDATE_SE_URL_FAILURE:
      return { ...state, loading: false, message: action.error, messageType: 'error' };
    case SET_DIGITAL_IMAGE_PREVIEW:
      return { ...state, digitalAssetsImgPreview: { ...state.digitalAssetsImgPreview, ...action.payload } };
    default:
      return state;
  }
}

export default reducer;
